/**
 * Cache durations for the React Query flows covered by INS-4022.
 *
 * Deliberately a standalone, side-effect-free module rather than living in
 * config/query-client.config.ts: that module constructs the app-wide QueryClient at import time,
 * so putting the TTL there would make every consumer of this number instantiate a client - which
 * breaks specs that partially mock @tanstack/react-query without QueryClient.
 */
// 10 minutes - see INS-4022 dev note ("we can consider caching for 5 to 10 minutes"). Applied as
// both staleTime and cacheTime on the flows that ticket covers; the QueryClient defaults still
// apply to everything else.
export var CACHE_TTL = 10 * 60 * 1000;
